import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames/bind';
import actions from '../../redux/actions';
import publicImage from '../../utils/publicImage';
import Breadcrumb from '../Breadcrumb';
import FilterSection from './FilterSection';
import SubFilterSection from '../SubFilterSection';
import SortSection from './SortSection';
import Workshop from './Workshop';
import MapSection from '../MapSection';
import FilterCategory from './FilterCategory';
import {
  IBreadCrumb,
  IState,
  IVehicle,
  ITWorkshop,
  IModal,
  ICoordinate,
  Replacement,
  ICountry,
  LocationCategory,
} from '../../interface';
import Header from '../Header';
import style from './index.module.scss';
import { getLangs, getLocations,  } from '../../services';
import { usePosition } from '../../hooks/use-position';
import moment from 'moment';
import { ModalHref } from '../../interface/emnu';
import Modal from '../Modal';
import Contact from '../Contact';
import Book from '../Book';
import Paginator from '../Paginator';
import {
  NODISTANCECOUNTRIES,
  PERPAGEFORNODISTANCE,
  PREPAGE,
  RETAIL_OUTLET,
  UNDETECT_LOCATION_PERMISSIONS,
} from '../../constants';
import Loading from '../Loading';
import { useLoadScript } from '@react-google-maps/api';
import { libraries } from '../../config/mapConfig';
import localesReplacement from '../../utils/localesReplacement';
import UnderMaintenance from '../UnderMaintenance';
import {Library} from '@googlemaps/js-api-loader';

/* eslint-disable */

const cx = classnames.bind(style);

type Libraries =
  | "drawing"
  | "geometry"
  | "localContext"
  | "places"
  | "visualization";

interface IProps {
  state: IState;
  modal: IModal;
  country: ICountry;
  replacements: Replacement;
  setVehicle: (value: IVehicle) => void;
  setWorkshops: (value: ITWorkshop[]) => void;
  setModal: (value: IModal) => void;
  locationCategoriesList: LocationCategory[] | null;
}

const WhereToBuy = React.memo(
  function _WhereToBuy(props: IProps) {
    const {
      state,
      modal,
      replacements,
      setWorkshops,
      setModal,
      country,
      locationCategoriesList,
    } = props;
    const [searchText, setSearchText] = useState({
      text: "",
      isClicked: false,
    });

    const [positon] = usePosition(props.country.name, replacements);
    const currentPositon =
      props.country.name !== "Georgia"
        ? positon
        : { lat: 41.69411, lng: 44.83368 };
    const navigate = useNavigate();
    const [mapAccord, setMapAccord] = useState<boolean>(false);
    const [mapAccordMobile, setMapAccordMobile] = useState<boolean>(false);
    const [filterOverlay, setFilterOverlay] = useState<boolean>(false);
    const [selectedLocation, setSelectedLocation] = useState<ITWorkshop>();
    //const [locationMap, setLocationMap] = useState<ITWorkshop[]>();
    const [workshopsForMap, setWorkshopsForMap] = useState();
    const [underMaintnance, setUnderMaintenance] = useState<boolean>(false);
    let callCount: number = 0;
    //country.id
    const breadcrumb: IBreadCrumb[] = [
      {
        value: "Castrol",
        href: "#",
        static: true,
      },
      {
        value: "Oil Selector",
        href: "#",
        static: true,
      },
      {
        value: "Recommended oils",
        href: "#",
        static: true,
      },
      {
        value: "Where to Buy",
        static: true,
      },
    ];
    const [count, setCount] = useState<number>(0);
    const [pageIndex, setPageIndex] = useState<number>(0);
    const [mounted, setMounted] = useState<boolean>(true);
    const getWorkshop = (currentPositon: ICoordinate) => {
      let data = {
        page: pageIndex + 1,
        perPage: _.includes(NODISTANCECOUNTRIES, country.isoCode)
          ? PERPAGEFORNODISTANCE
          : PREPAGE,
        currentLatitude: currentPositon.lat,
        currentLongitude: currentPositon.lng,
        sortBy: state.sort,
        locationCategoryIds: state.filter.locationCategories
          ?.filter((x) => x !== "0")
          ?.join(","),
        productCategoryIds: state.filter.productCategories?.join(","),
        locationTypeIds: state.filter.locationType?.join(","),
        openingHourFrom: moment(state.filter.openHours, "HH")
          .minutes(0)
          .format("HH:mm"),
        openingHourTo: _.isEqual(
          moment(state.filter.closeHours, "HH").format("HH:mm"),
          "00:00"
        )
          ? "23:59"
          : moment(state.filter.closeHours, "HH").format("HH:mm"),
        distanceInMiles:
          state.filter.distance === "false"
            ? state.distanceInMilesOrKM.toString()
            : state.filter.distance,
        onlyCastrolCertified: state.filter.locationCategories?.some(
          (x) => x === "0"
        ),
        countryIds: country.id,
        isMiles: state.isMiles.toString(),
        distanceInMilesOrKM: state.distanceInMilesOrKM,
        text:searchText.text
      };
      setMounted(false);

      if(validateGetLocationsAPI(data)){
        getLocations(_.includes(NODISTANCECOUNTRIES, country.isoCode)
        ? _.omit(data, 'distanceInMiles')
        : data,
          ).then((d) => {
            setWorkshops(d.data.items);
            setCount(d.data.total);
            setMounted(true);
            if(d.status !== 200) {
              setUnderMaintenance(true);
            }
            if (!state.enableWtbDistanceFilter) {
              setMounted(false);
              data.perPage = count ? count : data.perPage;
              data.page = 0;
              getLocations(data,
              ).then((d) => {
                if(d !== undefined)
                {
                  setWorkshopsForMap(d.data.items);
                  setMounted(true);
                }
              })
            }
          });
      }
    };

    const validateGetLocationsAPI = (data: any) => {
      let isValid = true;
      if (data.distanceInMiles === "false") {
        isValid = false;
      }
      return isValid;
    };

    const validateEnableWtbDistanceFilter = (data: any) => {
      if (
        state.enableWtbDistanceFilter === false ||
        _.includes(NODISTANCECOUNTRIES, country.isoCode)
      ) {
        data = _.omit(data, "distanceInMiles");
      }
      return data;
    };

    const ref = useRef<ICoordinate>();
    const refState = useRef<IState>();
    useEffect(() => {
      if (_.includes(NODISTANCECOUNTRIES, country.isoCode)) {
        if (
          currentPositon &&
          state.filter.openHours &&
          state.filter.closeHours &&
          (!_.isEqual(ref.current, currentPositon) ||
            !_.isEqual(refState.current, state))
        ) {
          ref.current = currentPositon;
          refState.current = state;
          !!country.id &&
            getWorkshop(
              state.filter.address?.coordinate
                ? state.filter.address?.coordinate
                : currentPositon
            );
        }
      } else if (
        currentPositon &&
        state.filter.distance &&
        (!_.isEqual(ref.current, currentPositon) ||
          !_.isEqual(refState.current, state))
      ) {
        ref.current = currentPositon;
        refState.current = state;
        !!country.id &&
          getWorkshop(
            state.filter.address?.coordinate
              ? state.filter.address?.coordinate
              : currentPositon
          );
      }
    }, [
      pageIndex,
      state.sort,
      state.filter.productCategories,
      state.filter.locationCategories,
      state.filter.locationType,
      state.filter.openHours,
      state.filter.closeHours,
      state.filter.distance,
      state.filter.address,
      currentPositon,
      country,
      state.distanceInMilesOrKM,
      state.enableWtbDistanceFilter,
      searchText.isClicked
    ]);

    useEffect(() => {
      const body = document.body;
      window.scrollTo(0, 0);
      filterOverlay || state.modal.visibie
        ? body.classList.add("no-scroll")
        : body.classList.remove("no-scroll");
    }, [filterOverlay]);

    //Open Contact Modal
    const openContactModal = (workshop: ITWorkshop) => {
      setModal({ visibie: true, href: ModalHref.Contact });
      setSelectedLocation(workshop);
    };

    //Open Book Modal
    const openBookModal = (workshop: ITWorkshop) => {
      setModal({ visibie: true, href: ModalHref.Book });
      setSelectedLocation(workshop);
    };

    //Scroll top
    useEffect(() => {
      if (modal.visibie) {
        window.scrollTo(0, 0);
      }
    }, [modal]);

    const { isLoaded, loadError } = useLoadScript({
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY as string,
      id: 'script-loader',
      libraries: libraries as Library[],
      // ...otherOptions
    });

    if (loadError) {
      return <>Map cannot be loaded right now, sorry.</>;
    }

    const locCatNames = _.map(
      state.filter.locationCategories,
      (lc) =>
        _.find(locationCategoriesList, (l) => _.isEqual(lc, l.id.toString()))
          ?.name
    );


    useEffect(() => {
      sessionStorage.removeItem(UNDETECT_LOCATION_PERMISSIONS);
    }, []);

    const handleBack = () => {
      navigate(-1);
    };

    useEffect(() => {
      getLangs().then(
        d => {
          if(d.status !== 200) {
            setUnderMaintenance(true);
          }
        }
      )
    }, [])

    useEffect(() => {
      getLangs().then(
        d => {
          if(d.status !== 200) {
            setUnderMaintenance(true);
          }
        }
      )
    }, [])

    const handleSearch = () => {
      if(searchText.text !== ""){
        setSearchText(prev => {
          return{
            ...prev,
            isClicked:true,
          }
        })
      }
    };
    return (
      <div className="page wtb-page">
        <Header />
        <div className={cx("container")}>
          {/* Banner section */}
          <div className={cx("banner")}>
            <img src={publicImage("hero-image.gif")} />
          </div>
          {/* Breadcrumb and titie above banner */}
          <div className={cx("heading")}>
            <Breadcrumb dataList={breadcrumb} />
            <h2>
              {country.isoCode === "AUT"
                ? localesReplacement(
                    replacements,
                    "WHERE TO BUY OR SERVICE AUSTRIA"
                  )
                : localesReplacement(replacements, "WHERE TO BUY OR SERVICE")}
            </h2>
          </div>

          <div className={cx("back-btn-plece")}>
            <button
              onClick={handleBack}
              className={`${cx("primary-button")} ${cx("back")}`}
            >
              {localesReplacement(replacements, "Back")}
            </button>
          </div>

          {/* Main container */}
          {isLoaded && !_.isUndefined(currentPositon) && (
            underMaintnance ? (
              <div>
                <UnderMaintenance replacements={replacements} />
              </div>
            ) :
            (
              <div className={cx('main-content')}>
              {/* Top section for filter */}
              <FilterSection
                replacements={replacements}
                setOverlay={setFilterOverlay}
                position={currentPositon}
              />

              <div className={cx("results")}>
                <h3>
                  {localesReplacement(
                    replacements,
                    "Find the right Products or Services near you"
                  )}
                </h3>

                <p className={cx("total")}>
                  {count} {localesReplacement(replacements, "places near you")}
                </p>
                <div className={cx("filter-category-container")}>
                  <FilterCategory
                    overlay={filterOverlay}
                    setOverlay={setFilterOverlay}
                  />
                  <input
                    className={cx("search-box")}
                    value={searchText.text}
                    placeholder={localesReplacement(replacements,"Search workshop by name")}
                    onChange={(e) =>
                      setSearchText((prev) => {
                        return {
                          ...prev,
                          isClicked: false,
                          text: e.target.value,
                        };
                      })
                    }
                  />
                  <button className={cx("search-button")} onClick={handleSearch}>{localesReplacement(replacements,'Search')}</button>
                </div>

                <div className={cx("result-block", { expanded: mapAccord })}>
                  {/* List result */}
                  <div
                    className={cx({
                      "result-list": true,
                      "hide-mobile": mapAccordMobile,
                    })}
                  >
                    {/* Sub filter and sort and view section */}
                    <div className={cx("operations")}>
                      <div className={cx("block")}>
                        <SubFilterSection />
                      </div>
                      <div className={cx("block", "sort-block")}>
                        <SortSection setAccord={setMapAccordMobile} />
                      </div>
                    </div>
                    {mounted &&
                      (state.workshops.length ? (
                        <ul
                          className={cx(
                            "workshops",
                            _.includes(NODISTANCECOUNTRIES, country.isoCode)
                              ? "three-it"
                              : undefined
                          )}
                        >
                          {_.map(state.workshops, (workshop, index) => (
                            <li key={index}>
                              <Workshop
                                setAccord={setMapAccordMobile}
                                dataList={workshop}
                                onContactClick={openContactModal}
                                onBookClick={openBookModal}
                              />
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className={cx("no-match")}>
                          {localesReplacement(
                            replacements,
                            "No Castrol workshops/services available within your area of search"
                          )}
                          .
                        </p>
                      ))}
                    {mounted && (
                      <Paginator
                        count={Math.ceil(
                          count /
                            (_.includes(NODISTANCECOUNTRIES, country.isoCode)
                              ? PERPAGEFORNODISTANCE
                              : PREPAGE)
                        )}
                        pageIndex={pageIndex}
                        handlePageClick={setPageIndex}
                        className="pagination"
                      />
                    )}
                    {!mounted && <Loading className="wtb-loading" />}
                  </div>
                  {/* Map */}
                  {!!country.isoCode && (
                    <>
                      {_.includes(NODISTANCECOUNTRIES, country.isoCode) &&
                      _.includes(locCatNames, RETAIL_OUTLET) ? null : (
                        <div
                          className={cx({
                            "map-section": true,
                            "expanded-mobile": mapAccordMobile,
                          })}
                        >
                          <MapSection
                            accord={mapAccord}
                            mapAccordMobile={mapAccordMobile}
                            setAccord={setMapAccord}
                            setAccordMobile={setMapAccordMobile}
                            //dataList={locationMap}
                            manualLocation={state.filter.address}
                            onContactClick={openContactModal}
                            country={country.name}
                            enableWtbDistanceFilter={
                              state.enableWtbDistanceFilter
                                ? state.enableWtbDistanceFilter
                                : false
                            }
                            workshopsForMap={workshopsForMap}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            )
            
          )}
        </div>
        {_.isEqual(modal.href, ModalHref.Contact) && modal.visibie && (
          <Modal className="abs-modal">
            <Contact
              dismiss={() => setModal({ visibie: false, href: 0 })}
              selected={selectedLocation}
            />
          </Modal>
        )}
        {_.isEqual(modal.href, ModalHref.Book) && modal.visibie && (
          <Modal className="abs-modal">
            <Book
              dismiss={() => setModal({ visibie: false, href: 0 })}
              selected={selectedLocation}
            />
          </Modal>
        )}
      </div>
    );
  },
  (prev, next) => {
    return _.isEqual(prev.state, next.state) ? true : false;
  }
);

const mapStateToProps = (state: IState) => ({
  state: state,
  modal: state.modal,
  replacements: state.replacements,
  country: state.country,
  locationCategoriesList: state.locationCategoriesList,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setVehicle: (vehicle: IVehicle) => dispatch(actions.setVehicle(vehicle)),
  setWorkshops: (value: ITWorkshop[]) => dispatch(actions.setWorkshops(value)),
  setModal: (value: IModal) => dispatch(actions.setModal(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WhereToBuy);
